module.exports = __webpack_public_path__ + "fontawesome-webfont.d7c639084f684d66a1bc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-social/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 411
// module chunks = 2